module.exports = __webpack_public_path__ + "security-f047efcd6ff522d532645166289f1e12.webp";